import { CartError } from '../errors/cartError';
import { ErrorTypes } from '../errors/errorTypes';

interface CustomErrorResponse extends Error {
    response?: {
        data?: {
            fields?: { appointmentIds: string[] };
            errorCode?: number;
            message?: string;
        };
    };
}

const handleAddressErrors = (originalError: unknown, context: { origin: string }): CartError => {
    const typedError = originalError as CustomErrorResponse;
    const errorOrigin = context.origin;
    let error: CartError;
    switch (typedError.response?.data?.errorCode) {
        case 100:
            error = new CartError(
                ErrorTypes.EXPRESS_SHIPPING_INVALID_COUNTRY_ERROR,
                typedError.response.data.message,
                { errorOrigin },
            );
            break;
        case 103:
            error = new CartError(
                ErrorTypes.SHIPPING_INVALID_COUNTRY_ERROR,
                typedError.response.data.message,
                { errorOrigin },
            );
            break;
        case 104:
            error = new CartError(
                ErrorTypes.EXPRESS_SHIPPING_INVALID_ZIP_CODE_ERROR,
                typedError.response.data.message,
                { errorOrigin },
            );
            break;
        case 606:
            error = new CartError(
                ErrorTypes.INPUT_VALIDATION_ERROR,
                typedError.response.data.message,
                { errorOrigin },
            );
            break;
        default:
            error = new CartError(ErrorTypes.GENERAL_ADDRESS_ERROR, null, {
                errorOrigin,
                unhandledErrorCode: typedError.response?.data?.errorCode,
            });
    }

    return error;
};

const onCreateOrder = (
    error: unknown,
    context: {
        message?: string;
        origin: string;
        defaultErrorType?: string;
        withDefaultError?: boolean;
    },
): CartError =>
    context.withDefaultError
        ? new CartError(
              context.defaultErrorType ?? ErrorTypes.GENERIC_PAYPAL_EXPRESS_ERROR,
              context.message,
              {
                  error,
                  errorOrigin: context.origin,
              },
          )
        : handleAddressErrors(error, context);

export const useExpressCheckoutErrors = (): {
    onCreateOrder: typeof onCreateOrder;
    handleAddressErrors: typeof handleAddressErrors;
} => ({ onCreateOrder, handleAddressErrors });
